/* PawsOn 2026 — collection page.

   Filtering, sorting and load more all happen in place. Each is a progressive
   enhancement over markup that already works on its own: the facets are a real
   GET form, the sort chips and the load more button are real links, and every
   state has a real URL. Turn JavaScript off and the page still filters, sorts
   and paginates, just with a reload each time.

   What is swapped, and nothing else:
     [data-pw-results]  the active filter chips, the grid and the pagination
     [data-pw-count]    the heading
     .pw-facet bodies   the option counts, which change with the selection

   The facets themselves are not replaced wholesale, so which ones are open
   and where the rail is scrolled to both survive a filter change. */

(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.pwReady === 'true') return;
    root.dataset.pwReady = 'true';

    var form = root.querySelector('[data-pw-rail]');
    var results = root.querySelector('[data-pw-results]');
    if (!results) return;

    var pending = null;

    function swap(url, push) {
      if (pending) pending.abort();
      var controller = new AbortController();
      pending = controller;

      results.setAttribute('aria-busy', 'true');
      results.style.opacity = '0.55';

      fetch(url, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('filter failed');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var nextResults = doc.querySelector('[data-pw-results]');
          if (nextResults) results.innerHTML = nextResults.innerHTML;

          var count = root.querySelector('[data-pw-count]');
          var nextCount = doc.querySelector('[data-pw-count]');
          if (count && nextCount) count.textContent = nextCount.textContent;

          /* A box chip changes which collection is being shown, so the
             heading, the description and the breadcrumb all belong to a
             different page now. Left alone they described the collection the
             customer just navigated away from. */
          var hero = document.querySelector('[data-pw-hero]');
          var nextHero = doc.querySelector('[data-pw-hero]');
          if (hero && nextHero) hero.innerHTML = nextHero.innerHTML;

          var title = doc.querySelector('title');
          if (title) document.title = title.textContent;

          /* The box chips live outside the results, so which one is current
             has to be refreshed separately. */
          var chips = root.querySelector('[data-pw-chips]');
          var nextChips = doc.querySelector('[data-pw-chips]');
          if (chips && nextChips) {
            chips.innerHTML = nextChips.innerHTML;
            bindSwapLinks(chips);
          }

          /* Counts move with the selection, so the facet bodies are refreshed.
             The details elements themselves stay put, which is what keeps the
             open ones open and the rail where it was scrolled to. */
          var facets = root.querySelectorAll('[data-pw-rail] .pw-facet');
          var nextFacets = doc.querySelectorAll('[data-pw-rail] .pw-facet');
          facets.forEach(function (facet, i) {
            if (!nextFacets[i]) return;
            var body = facet.querySelector('.pw-facet__body');
            var nextBody = nextFacets[i].querySelector('.pw-facet__body');
            if (body && nextBody) {
              var scrolled = body.scrollTop;
              body.innerHTML = nextBody.innerHTML;
              body.scrollTop = scrolled;
            }
          });

          if (push && window.history && window.history.pushState) {
            window.history.pushState({ pwFilter: true }, '', url);
          }

          results.style.opacity = '';
          results.removeAttribute('aria-busy');
          pending = null;
          bindResults(root);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          /* Rather than leave the page half updated, fall back to the reload
             the markup would have done without any of this. */
          window.location.href = url;
        });
    }

    /* --- Facets --- */

    if (form) {
      form.addEventListener('change', function (event) {
        if (event.target.type !== 'checkbox') return;
        var query = new URLSearchParams(new FormData(form)).toString();
        swap(form.getAttribute('action') + (query ? '?' + query : ''), true);
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var query = new URLSearchParams(new FormData(form)).toString();
        swap(form.getAttribute('action') + (query ? '?' + query : ''), true);
      });

      var clear = form.querySelector('.pw-crail__clear');
      if (clear) {
        clear.addEventListener('click', function (event) {
          event.preventDefault();
          swap(clear.getAttribute('href'), true);
        });
      }
    }

    /* --- Sort chips, box filter chips, anything that re-queries --- */

    function bindSwapLinks(scope) {
      scope.querySelectorAll('.pw-sortchip, [data-pw-swap]').forEach(function (link) {
        if (link.dataset.pwBound === 'true') return;
        link.dataset.pwBound = 'true';
        link.addEventListener('click', function (event) {
          event.preventDefault();
          swap(link.getAttribute('href'), true);
        });
      });
    }

    bindSwapLinks(root);

    function bindResults(scope) {
      /* Removing a filter from a chip, and clearing from the empty state. */
      scope.querySelectorAll('[data-pw-results] a').forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (link.closest('.pw-ccard')) return;
        if (href.indexOf('/collections/') !== 0) return;
        if (link.dataset.pwBound === 'true') return;
        link.dataset.pwBound = 'true';
        link.addEventListener('click', function (event) {
          event.preventDefault();
          swap(href, true);
        });
      });

      initLoadMore(scope);
    }

    /* --- Load more --- */

    function initLoadMore(scope) {
      var button = scope.querySelector('[data-pw-loadmore]');
      var grid = scope.querySelector('[data-pw-grid]');
      var wrap = scope.querySelector('[data-pw-more]');
      if (!button || !grid || !wrap || button.dataset.pwBound === 'true') return;
      button.dataset.pwBound = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        var url = button.getAttribute('href');
        button.setAttribute('aria-busy', 'true');

        fetch(url)
          .then(function (response) {
            if (!response.ok) throw new Error('load more failed');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextGrid = doc.querySelector('[data-pw-grid]');
            var nextMore = doc.querySelector('[data-pw-more]');

            if (nextGrid) {
              Array.prototype.slice.call(nextGrid.children).forEach(function (card) {
                grid.appendChild(card);
              });
            }

            if (nextMore) {
              wrap.replaceWith(nextMore);
              initLoadMore(scope);
            } else {
              wrap.remove();
            }

            if (window.history && window.history.replaceState) {
              window.history.replaceState({}, '', url);
            }
          })
          .catch(function () {
            window.location.href = url;
          });
      });
    }

    /* Back and forward have to put the grid back, not just the address bar. */
    window.addEventListener('popstate', function () {
      swap(window.location.href, false);
    });

    bindResults(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.pw-collection-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
